const TARGET_SIZE = 5;
const VERTICAL = 0;
const HORIZONTAL = 1;

export { TARGET_SIZE, VERTICAL, HORIZONTAL };
